<div class="container-fluid" style="padding:0">
    <div class="row">
        <div class="col-lg-2">
            <app-navbar></app-navbar>
        </div>  
        <div class="col-lg-10">
            <div class="row">
                <div class="col-lg-3">
                    <br><br>
                    <h3 class="titulo">Insumos</h3>
                </div>
                <div class="col-lg-3">
                    <br><br>
                    <select class="form-control" [(ngModel)]="filtro.activo" (change)="getInsumosFilter();">
                        <option value="1">Activos</option>
                        <option value="0">Inactivos</option>
                    </select>
                </div>
                <div class="col-lg-3">
                    <br><br>
                    <select class="form-control" [(ngModel)]="filtro.categoria" (change)="getInsumosFilter();">
                        <option value="">Seleccione Categoria</option>
                        <option *ngFor="let categoria of categorias" [value]="categoria.id">{{categoria.nombre}}</option>
                    </select>
                </div>
                

                <!-- <div class="col-lg-3">
                    <br><br>
                    <select class="form-control" [(ngModel)]="filtro.proveedor" (change)="getInsumosFilter();">
                        <option value="">Seleccione Proveedor</option>
                        <option *ngFor="let proveedorF of proveedores" [value]="proveedorF.id">{{proveedorF.nombre_razon_social}}</option>
                    </select><br>
                </div> -->
                <div class="col-lg-3">
                    <br><br>
                    <button class="boton fondoAmarillo blanco bold" (click)="openModal(agregarProductoModal)">Nuevo Insumo</button>
                </div>
            </div>
            <br>
            
            <div class="row">
                <div class="col-lg-11">
                    <table class="table table-striped center">
                        <thead>
                            <tr>
                                <td>Imagen</td>
                                <td>Insumo</td>
                                <td>Contenido</td>
                                <td>Marca</td>
                                <td>Factor de Conversión</td>
                                <td>Unidad de Medida Almacén</td>
                                <td>Unidad de Medida Proveedor</td>
                                <td>Paquete</td>
                                <td>Precio Inicial</td>
                                <td>Categoria</td>
                                <td>Último Proveedor</td>
                                <td>Editar</td>
                                <!-- <td>
                                    <div *ngIf="activo == 1">Desactivar</div>
                                    <div *ngIf="activo == 0">Activar</div>
                                </td> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let producto of productos">
                                <td>
                                    <div  *ngIf="producto.imagen; else imagenDefault">
                                        <img src="{{environment}}{{producto.imagen}}" width="200px">
                                    </div>
                                    <ng-template #imagenDefault>
                                        <img src="assets/img/logo_salvaje_blanco.png" width="100px">
                                    </ng-template>
                                </td>
                                <td>{{producto.nombre}}</td>
                                <td>{{producto.contenido}}</td>
                                <td>{{producto.marca}}</td>
                                <td>{{producto.factor_conversion}}</td>
                                <td>{{producto.unidad_medida}}</td>
                                <td>{{producto.unidad_medida_proveedor}}</td>
                                <td>{{producto.paquete}}</td>
                                <td>{{producto.precio_inicial |currency}}</td>
                                <td>{{producto.clasificacion_gasto}}</td>
                                <td>{{producto.ultimo_proveedor}}</td>
                                <td><a (click)="editarInsumo(producto.id)">
                                    <svg  style="color:gray" width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-pencil-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z"/>
                                    </svg>
                                </a>
                                </td>
                                <!-- <td>
                                    <div *ngIf="activo == 1">
                                        <label class="switch">
                                            <input type="checkbox" checked (click)="desactivarInsumo(producto.id)">
                                            <span class="slider round"></span>
                                        </label>
                                    </div>

                                    <div *ngIf="activo == 0">
                                        <label class="switch">
                                            <input type="checkbox" (click)="activarInsumo(producto.id)">
                                            <span class="slider round"></span>
                                        </label>
                                    </div>
                                
                                </td> -->
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-lg-1"></div>
            </div>
        </div>
    </div>
</div>


<ng-template #agregarProductoModal let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h2>Agregar Insumo</h2>
      <button type="button" class="close" (click)="dismissAll()" data-dismiss="modal">&times;</button>
    </div>
    
    <div class="modal-body">
        <span class="bold">Nombre</span><br>
        <input type="text" class="form-control" placeholder="Nombre" [(ngModel)]="formulario.nombre"><br>
        <span class="bold">Contenido</span><br>
        <input type="text" class="form-control" placeholder="Contenido" [(ngModel)]="formulario.contenido"><br>
        
        <span class="bold">Marca</span><br>
        <input type="text" class="form-control" placeholder="Marca" [(ngModel)]="formulario.marca"><br>

        <span class="bold">Último Precio:</span><br>
        <input type="text" class="form-control" placeholder="Precio" [(ngModel)]="formulario.precio"><br>

        <span class="bold">Factor de Conversión:</span><br>
        <input type="text" class="form-control" placeholder="Factor de Conversión" [(ngModel)]="formulario.factor_conversion"><br>

        <span class="bold">Unidad de Medida:</span><br>
        <select class="form-control" [(ngModel)]="formulario.unidad_medida">
            <option value="">Seleccione Unidad de Medida</option>
            <option *ngFor="let unidadA of unidades" [value]="unidadA.id">{{unidadA.nombre}}</option>
        </select><br>

        <span class="bold">Unidad de Medida Proveedor:</span><br>
        <select class="form-control" [(ngModel)]="formulario.unidad_medida_proveedor">
            <option value="">Seleccione Unidad de Medida Proveedor</option>
            <option *ngFor="let unidadAP of unidades" [value]="unidadAP.id">{{unidadAP.nombre}}</option>
        </select><br>

        <span class="bold">Categoria:</span><br>
        <select class="form-control" [(ngModel)]="formulario.clasificacion_gasto">
            <option value="">Seleccione Categoria</option>
            <option *ngFor="let categoriaA of categorias" [value]="categoriaA.id">{{categoriaA.nombre}}</option>
        </select><br>

        <span class="bold">Proveeedor preferido:</span><br>
        <select class="form-control" [(ngModel)]="formulario.proveedor">
            <option value="">Seleccione Proveedor</option>
            <option *ngFor="let proveedorA of proveedores" [value]="proveedorA.id">{{proveedorA.nombre_razon_social}}</option>
        </select><br>

        Imagen:<br>
        <input (change)="fileChange($event)" type="file"accept="image/*" id="imagen"><br><br>
    </div>

    <div class="modal-footer">
        <button class="btn btn-primary" (click)="agregarInsumo()">Agregar Producto</button>
    </div>
</ng-template>


<div id="clickEditar" (click)="openModal(myModalEditar)"></div>
<ng-template #myModalEditar let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h2>Editar Insumo</h2>
      <button type="button" class="close" (click)="dismissAll()" data-dismiss="modal">&times;</button>
    </div>

    <div class="modal-body">
        <span class="bold">Nombre</span><br>
        <input type="text" class="form-control" placeholder="Nombre" [(ngModel)]="formularioEdit.nombre"><br>

        <span class="bold">Contenido</span><br>
        <input type="text" class="form-control" placeholder="Contenido" [(ngModel)]="formularioEdit.contenido"><br>

        <span class="bold">Marca</span><br>
        <input type="text" class="form-control" placeholder="Marca" [(ngModel)]="formularioEdit.marca"><br>

        <span class="bold">Último Precio</span><br>
        <input type="text" class="form-control" placeholder="Precio" [(ngModel)]="formularioEdit.precio"><br>

        <span class="bold">Categoría</span><br>
        <select class="form-control" [(ngModel)]="formularioEdit.clasificacion_gasto">
            <option value="">Seleccione Categoria</option>
            <option *ngFor="let categoriaE of categorias" [value]="categoriaE.id">{{categoriaE.nombre}}</option>
        </select><br>

        <span class="bold">Factor de Conversión:</span><br>
        <input type="text" class="form-control" placeholder="Factor de Conversión" [(ngModel)]="formularioEdit.factor_conversion"><br>

        <span class="bold">Unidad de Medida:</span><br>
        <select class="form-control" [(ngModel)]="formularioEdit.unidad_medida">
            <option value="">Seleccione Unidad de Medida</option>
            <option *ngFor="let unidadE of unidades" [value]="unidadE.id">{{unidadE.nombre}}</option>
        </select><br>

        <span class="bold">Unidad de Medida Proveedor:</span><br>
        <select class="form-control" [(ngModel)]="formularioEdit.unidad_medida_proveedor">
            <option value="">Seleccione Unidad de Medida Proveedor</option>
            <option *ngFor="let unidadEp of unidades" [value]="unidadEp.id">{{unidadEp.nombre}}</option>
        </select><br>


        <span class="bold">Proveeedor preferido:</span><br>
        <select class="form-control" [(ngModel)]="formularioEdit.proveedor">
            <option value="">Seleccione Proveedor</option>
            <option *ngFor="let proveedorE of proveedores" [value]="proveedorE.id">{{proveedorE.nombre_razon_social}}</option>
        </select><br>
        <div *ngIf="">
            <img src="{{environment}}{{imagenActual}}" height="300px"><br>
        </div>
        
        Imagen:<br>
        <input (change)="fileChangeEdit($event)" type="file"accept="image/*" id="imagen"><br><br>
    </div>

    <div class="modal-footer">
        <button class="btn btn-primary" (click)="updateInsumo(insumoid)">Editar Insumo</button>
    </div>
</ng-template>
